var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 0,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 69,
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.26,33.3c-1.98,0-3.97.04-5.95,0-4.89-.12-8.81-4.15-8.82-9.03,0-3.75,0-7.51,0-11.26,0-4.38,2.82-7.97,7.08-8.98.71-.17,1.47-.23,2.2-.24,3.66-.02,7.32-.02,10.99-.01,4.78,0,8.55,3.29,9.21,8.02.06.4.05.82.05,1.22,0,3.93.07,7.87-.04,11.8-.11,4.11-3.44,7.76-7.52,8.36-.97.14-1.96.12-2.94.13-1.42.02-2.84,0-4.27,0,0,0,0,0,0,0ZM10.01,18.51c-.01,5.11,4.11,9.29,9.18,9.3,5.18.01,9.35-4.1,9.37-9.26.02-5.1-4.13-9.26-9.26-9.27-5.13-.01-9.27,4.1-9.28,9.23ZM31.12,9.28c0-1.45-1.15-2.6-2.58-2.6-1.42,0-2.6,1.2-2.59,2.61.01,1.44,1.17,2.57,2.62,2.57,1.42,0,2.56-1.15,2.55-2.57ZM1.03,18.54s-.03,0-.04,0c0,2.12,0,4.24,0,6.35,0,.68,0,1.37.09,2.04.76,5.75,5.48,9.88,11.28,9.88,4.66,0,9.32,0,13.98,0,.56,0,1.12-.03,1.67-.12,5.61-.92,9.54-5.57,9.54-11.25,0-4.58,0-9.17,0-13.75,0-.62-.02-1.25-.12-1.85C36.5,4.2,31.85.26,26.14.25c-4.57,0-9.14,0-13.71,0-1.39,0-2.75.17-4.04.7C3.98,2.73,1.42,5.98,1.06,10.74c-.19,2.59-.03,5.2-.03,7.8ZM24.83,18.58c.04,2.94-2.44,5.49-5.36,5.53-3.2.04-5.73-2.37-5.78-5.49-.05-3.07,2.45-5.62,5.54-5.65,3.09-.04,5.56,2.45,5.6,5.62Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a6d8ba0d5f95360068fba79217b8b54b.svg";
export { ForwardRef as ReactComponent };